import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()

export class ApiEndpointsService {

  private endpoints = ENDPOINTS;

  constructor() {
  }

  get(name: EndpointKey, params?: any): string | null {
    const index: number = _.findIndex(this.endpoints, d => d.key === name);

    if (index !== -1) {
      if (params) {
        const url: string = this.endpoints[index].route;

        return url.replace(/(:[a-zA-Z_]+)/g, m => {
          return params[m];
        });
      } else {
        return this.endpoints[index].route;
      }
    }

    throw new Error('Unknown route URL requested: ' + name);
  }
}

const ENDPOINTS = [
  {key: 'public.default-organisation', route: 'v1/public/default-organisation'},

  {key: 'auth.login', route: 'auth/login'},
  {key: 'auth.login.2fa', route: 'auth/login/two-factor'},
  {key: 'auth.logout', route: 'auth/logout'},
  {key: 'auth.forgot-password', route: 'auth/forgot-password'},
  {key: 'auth.reset-password.validate', route: 'auth/reset-password/:token?email=:email'},
  {key: 'auth.reset-password', route: 'auth/reset-password'},
  {key: 'auth.change-password', route: 'auth/change-password'},
  {key: 'auth.complete-account', route: 'auth/complete-account/:id?expires=:expires&signature=:signature'},
  {key: 'auth.account', route: 'auth/account'},
  {key: 'auth.impersonate', route: 'auth/impersonate'},
  {key: 'auth.availability', route: 'auth/availability'},
  {key: 'auth.two-factor-auth.enable', route: 'auth/two-factor-authentication/enable'},
  {key: 'auth.two-factor-auth.disable', route: 'auth/two-factor-authentication/disable'},
  {key: 'auth.two-factor-auth.confirm', route: 'auth/two-factor-authentication/confirm'},
  {key: 'auth.two-factor-auth.recovery-codes', route: 'auth/two-factor-authentication/recovery-codes'},
  {key: 'auth.two-factor-auth.regenerate-recovery-codes', route: 'auth/two-factor-authentication/regenerate-recovery-codes'},

  {key: 'filters.departments', route: 'v1/filters/departments'},
  {key: 'filters.departments-and-users', route: 'v1/filters/departments-and-users'},
  {key: 'filters.department-users', route: 'v1/filters/departments/:id/users'},
  {key: 'filters.permissions', route: 'v1/filters/permissions'},
  {key: 'filters.permission-groups', route: 'v1/filters/permissions/groups'},
  {key: 'filters.roles', route: 'v1/filters/roles'},
  {key: 'filters.priorities', route: 'v1/filters/priorities'},
  {key: 'filters.statuses', route: 'v1/filters/statuses'},
  {key: 'filters.history-types', route: 'v1/filters/history-types'},
  {key: 'filters.history-entry-types', route: 'v1/filters/history-entry-types'},
  {key: 'filters.users', route: 'v1/filters/users'},
  {key: 'filters.users.can-be-assigned', route: 'v1/filters/users/can-be-assigned'},
  {key: 'filters.basic-registrations', route: 'v1/filters/basic-registrations'},
  {key: 'filters.basic-registrations.task-registrations', route: 'v1/filters/basic-registrations/:basic_registration_id/task-registrations'},
  {key: 'filters.task-registrations', route: 'v1/filters/task-registrations'},
  {key: 'filters.sources', route: 'v1/filters/sources'},
  {key: 'filters.actions', route: 'v1/filters/actions'},
  {key: 'filters.currents', route: 'v1/filters/currents'},
  {key: 'filters.impact-registrations', route: 'v1/filters/impact-registrations'},
  {key: 'filters.tiles', route: 'v1/filters/tiles'},
  {key: 'filters.tiles.read', route: 'v1/filters/tiles/:id'},
  {key: 'filters.address-book', route: 'v1/filters/address-book'},
  {key: 'filters.domain-types', route: 'v1/filters/domain-types'},
  {key: 'filters.standard-reactions', route: 'v1/filters/standard-reactions'},
  {key: 'filters.address-book-types', route: 'v1/filters/address-book-types'},
  {key: 'filters.knowledge-base.changelogs.types', route: 'v1/filters/knowledge-base/changelogs/types'},
  {key: 'filters.sent-emails.events', route: 'v1/filters/sent-emails/events'},
  {key: 'filters.sent-emails.log-levels', route: 'v1/filters/sent-emails/log-levels'},
  {key: 'filters.sent-emails.tags', route: 'v1/filters/sent-emails/tags'},
  {key: 'filters.holiday-types', route: 'v1/filters/holiday-types'},
  {key: 'filters.holiday-regional-scopes', route: 'v1/filters/holiday-regional-scopes'},
  {key: 'filters.holiday-temporal-scopes', route: 'v1/filters/holiday-temporal-scopes'},

  {key: 'routering.actions.index', route: 'v1/configuration/actions'},
  {key: 'routering.actions.create', route: 'v1/configuration/actions'},
  {key: 'routering.actions.read', route: 'v1/configuration/actions/:id'},
  {key: 'routering.actions.update', route: 'v1/configuration/actions/:id'},
  {key: 'routering.actions.delete', route: 'v1/configuration/actions/:id'},
  {key: 'routering.actions.restore', route: 'v1/configuration/actions/:id/restore'},
  {key: 'routering.basic-registrations.index', route: 'v1/configuration/basic-registrations'},
  {key: 'routering.basic-registrations.create', route: 'v1/configuration/basic-registrations'},
  {key: 'routering.basic-registrations.read', route: 'v1/configuration/basic-registrations/:id'},
  {key: 'routering.basic-registrations.update', route: 'v1/configuration/basic-registrations/:id'},
  {key: 'routering.basic-registrations.delete', route: 'v1/configuration/basic-registrations/:id'},
  {key: 'routering.basic-registrations.restore', route: 'v1/configuration/basic-registrations/:id/restore'},
  {key: 'routering.task-registrations.index', route: 'v1/configuration/basic-registrations/:basic_registration_id/task-registrations'},
  {key: 'routering.task-registrations.create', route: 'v1/configuration/basic-registrations/:basic_registration_id/task-registrations'},
  {key: 'routering.task-registrations.read', route: 'v1/configuration/basic-registrations/:basic_registration_id/task-registrations/:id'},
  {key: 'routering.task-registrations.update', route: 'v1/configuration/basic-registrations/:basic_registration_id/task-registrations/:id'},
  {key: 'routering.task-registrations.delete', route: 'v1/configuration/basic-registrations/:basic_registration_id/task-registrations/:id'},
  {key: 'routering.task-registrations.restore', route: 'v1/configuration/basic-registrations/:basic_registration_id/task-registrations/:id/restore'},
  {key: 'routering.categories.overview', route: 'v1/configuration/categories/overview'},
  {key: 'routering.categories.overview.export', route: 'v1/configuration/categories/overview/export'},
  {key: 'routering.departments.index', route: 'v1/configuration/departments'},
  {key: 'routering.departments.create', route: 'v1/configuration/departments'},
  {key: 'routering.departments.read', route: 'v1/configuration/departments/:id'},
  {key: 'routering.departments.update', route: 'v1/configuration/departments/:id'},
  {key: 'routering.departments.delete', route: 'v1/configuration/departments/:id'},
  {key: 'routering.departments.sort', route: 'v1/configuration/departments/sort'},
  {key: 'routering.departments.restore', route: 'v1/configuration/departments/:id/restore'},
  {key: 'routering.roles.index', route: 'v1/configuration/roles'},
  {key: 'routering.roles.overview', route: 'v1/configuration/roles/overview'},
  {key: 'routering.roles.create', route: 'v1/configuration/roles'},
  {key: 'routering.roles.read', route: 'v1/configuration/roles/:id'},
  {key: 'routering.roles.update', route: 'v1/configuration/roles/:id'},
  {key: 'routering.roles.delete', route: 'v1/configuration/roles/:id'},
  {key: 'routering.sources.index', route: 'v1/configuration/sources'},
  {key: 'routering.sources.create', route: 'v1/configuration/sources'},
  {key: 'routering.sources.read', route: 'v1/configuration/sources/:id'},
  {key: 'routering.sources.update', route: 'v1/configuration/sources/:id'},
  {key: 'routering.sources.delete', route: 'v1/configuration/sources/:id'},
  {key: 'routering.sources.restore', route: 'v1/configuration/sources/:id/restore'},
  {key: 'routering.tiles.index', route: 'v1/configuration/tiles'},
  {key: 'routering.tiles.read', route: 'v1/configuration/tiles/:id'},
  {key: 'routering.tiles.update', route: 'v1/configuration/tiles/:id'},
  {key: 'routering.users.index', route: 'v1/configuration/users'},
  {key: 'routering.users.create', route: 'v1/configuration/users'},
  {key: 'routering.users.read', route: 'v1/configuration/users/:id'},
  {key: 'routering.users.update', route: 'v1/configuration/users/:id'},
  {key: 'routering.users.delete', route: 'v1/configuration/users/:id'},
  {key: 'routering.users.restore', route: 'v1/configuration/users/:id/restore'},
  {key: 'routering.users.resend-invitation', route: 'v1/configuration/users/:id/resend-invitation'},
  {key: 'routering.users.audit-logs', route: 'v1/configuration/users/:id/audit-logs'},
  {key: 'routering.organisation.read', route: 'v1/configuration/organisation'},
  {key: 'routering.organisation.update', route: 'v1/configuration/organisation'},

  {key: 'configuration.address-book.index', route: 'v1/configuration/address-book'},
  {key: 'configuration.address-book.create', route: 'v1/configuration/address-book'},
  {key: 'configuration.address-book.read', route: 'v1/configuration/address-book/:id'},
  {key: 'configuration.address-book.update', route: 'v1/configuration/address-book/:id'},
  {key: 'configuration.address-book.delete', route: 'v1/configuration/address-book/:id'},
  {key: 'configuration.address-book.restore', route: 'v1/configuration/address-book/:id/restore'},
  {key: 'configuration.email-templates.index', route: 'v1/configuration/email-templates'},
  {key: 'configuration.email-templates.read', route: 'v1/configuration/email-templates/:id'},
  {key: 'configuration.email-templates.update', route: 'v1/configuration/email-templates/:id'},
  {key: 'configuration.standard-reactions.index', route: 'v1/configuration/standard-reactions'},
  {key: 'configuration.standard-reactions.create', route: 'v1/configuration/standard-reactions'},
  {key: 'configuration.standard-reactions.read', route: 'v1/configuration/standard-reactions/:id'},
  {key: 'configuration.standard-reactions.update', route: 'v1/configuration/standard-reactions/:id'},
  {key: 'configuration.standard-reactions.delete', route: 'v1/configuration/standard-reactions/:id'},
  {key: 'configuration.standard-reactions.restore', route: 'v1/configuration/standard-reactions/:id/restore'},

  {key: 'configuration.knowledge-base.index', route: 'v1/configuration/knowledge-base'},
  {key: 'configuration.knowledge-base.create', route: 'v1/configuration/knowledge-base'},
  {key: 'configuration.knowledge-base.create-upload-media', route: 'v1/configuration/knowledge-base/media'},
  {key: 'configuration.knowledge-base.sort', route: 'v1/configuration/knowledge-base/sort'},
  {key: 'configuration.knowledge-base.read', route: 'v1/configuration/knowledge-base/:id'},
  {key: 'configuration.knowledge-base.update', route: 'v1/configuration/knowledge-base/:id'},
  {key: 'configuration.knowledge-base.update-upload-media', route: 'v1/configuration/knowledge-base/:id/media'},
  {key: 'configuration.knowledge-base.delete', route: 'v1/configuration/knowledge-base/:id'},
  {key: 'configuration.knowledge-base.restore', route: 'v1/configuration/knowledge-base/:id/restore'},
  {key: 'configuration.knowledge-base-articles.index', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles'},
  {key: 'configuration.knowledge-base-articles.create', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles'},
  {key: 'configuration.knowledge-base-articles.create-upload-media', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/media'},
  {key: 'configuration.knowledge-base-articles.sort', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/sort'},
  {key: 'configuration.knowledge-base-articles.read', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/:id'},
  {key: 'configuration.knowledge-base-articles.update', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/:id'},
  {key: 'configuration.knowledge-base-articles.update-upload-media', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/:id/media'},
  {key: 'configuration.knowledge-base-articles.delete', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/:id'},
  {key: 'configuration.knowledge-base-articles.restore', route: 'v1/configuration/knowledge-base/:knowledge_base_id/articles/:id/restore'},
  {key: 'configuration.knowledge-base.faq.index', route: 'v1/configuration/knowledge-base/faq'},
  {key: 'configuration.knowledge-base.faq.create', route: 'v1/configuration/knowledge-base/faq'},
  {key: 'configuration.knowledge-base.faq.sort', route: 'v1/configuration/knowledge-base/faq/sort'},
  {key: 'configuration.knowledge-base.faq.read', route: 'v1/configuration/knowledge-base/faq/:id'},
  {key: 'configuration.knowledge-base.faq.update', route: 'v1/configuration/knowledge-base/faq/:id'},
  {key: 'configuration.knowledge-base.faq.delete', route: 'v1/configuration/knowledge-base/faq/:id'},
  {key: 'configuration.knowledge-base.faq.restore', route: 'v1/configuration/knowledge-base/faq/:id/restore'},
  {key: 'configuration.knowledge-base.support-contact-details', route: 'v1/configuration/knowledge-base/support-contact-details'},
  {key: 'configuration.knowledge-base.changelogs.index', route: 'v1/configuration/knowledge-base/changelogs'},
  {key: 'configuration.knowledge-base.changelogs.create', route: 'v1/configuration/knowledge-base/changelogs'},
  {key: 'configuration.knowledge-base.changelogs.read', route: 'v1/configuration/knowledge-base/changelogs/:id'},
  {key: 'configuration.knowledge-base.changelogs.update', route: 'v1/configuration/knowledge-base/changelogs/:id'},
  {key: 'configuration.knowledge-base.changelogs.delete', route: 'v1/configuration/knowledge-base/changelogs/:id'},
  {key: 'configuration.knowledge-base.changelogs.articles.index', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles'},
  {key: 'configuration.knowledge-base.changelogs.articles.create', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles'},
  {key: 'configuration.knowledge-base.changelogs.articles.sort', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles/sort'},
  {key: 'configuration.knowledge-base.changelogs.articles.create-upload-media', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles/media'},
  {key: 'configuration.knowledge-base.changelogs.articles.read', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles/:id'},
  {key: 'configuration.knowledge-base.changelogs.articles.update', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles/:id'},
  {key: 'configuration.knowledge-base.changelogs.articles.update-upload-media', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles/:id/media'},
  {key: 'configuration.knowledge-base.changelogs.articles.delete', route: 'v1/configuration/knowledge-base/changelogs/:changelog_id/articles/:id'},
  {key: 'configuration.knowledge-base.changelogs.types.index', route: 'v1/configuration/knowledge-base/changelogs/types'},
  {key: 'configuration.knowledge-base.changelogs.types.create', route: 'v1/configuration/knowledge-base/changelogs/types'},
  {key: 'configuration.knowledge-base.changelogs.types.read', route: 'v1/configuration/knowledge-base/changelogs/types/:id'},
  {key: 'configuration.knowledge-base.changelogs.types.update', route: 'v1/configuration/knowledge-base/changelogs/types/:id'},
  {key: 'configuration.knowledge-base.changelogs.types.delete', route: 'v1/configuration/knowledge-base/changelogs/types/:id'},

  {key: 'configuration.priorities.index', route: 'v1/configuration/priorities'},
  {key: 'configuration.priorities.read', route: 'v1/configuration/priorities/:id'},
  {key: 'configuration.priorities.update', route: 'v1/configuration/priorities/:id'},
  {key: 'configuration.priorities.sort', route: 'v1/configuration/priorities/sort'},
  {key: 'configuration.statuses.index', route: 'v1/configuration/statuses'},
  {key: 'configuration.statuses.read', route: 'v1/configuration/statuses/:id'},
  {key: 'configuration.statuses.update', route: 'v1/configuration/statuses/:id'},
  {key: 'configuration.statuses.sort', route: 'v1/configuration/statuses/sort'},
  {key: 'configuration.history-types.index', route: 'v1/configuration/history-types'},
  {key: 'configuration.history-types.read', route: 'v1/configuration/history-types/:id'},
  {key: 'configuration.history-types.update', route: 'v1/configuration/history-types/:id'},
  {key: 'configuration.holidays.index', route: 'v1/configuration/holidays'},
  {key: 'configuration.holidays.create', route: 'v1/configuration/holidays'},
  {key: 'configuration.holidays.read', route: 'v1/configuration/holidays/:id'},
  {key: 'configuration.holidays.update', route: 'v1/configuration/holidays/:id'},
  {key: 'configuration.holidays.delete', route: 'v1/configuration/holidays/:id'},
  {key: 'configuration.currents.index', route: 'v1/configuration/currents'},
  {key: 'configuration.currents.create', route: 'v1/configuration/currents'},
  {key: 'configuration.currents.sort', route: 'v1/configuration/currents/sort'},
  {key: 'configuration.currents.read', route: 'v1/configuration/currents/:id'},
  {key: 'configuration.currents.update', route: 'v1/configuration/currents/:id'},
  {key: 'configuration.currents.delete', route: 'v1/configuration/currents/:id'},
  {key: 'configuration.currents.restore', route: 'v1/configuration/currents/:id/restore'},
  {key: 'configuration.impact-registrations.index', route: 'v1/configuration/impact-registrations'},
  {key: 'configuration.impact-registrations.create', route: 'v1/configuration/impact-registrations'},
  {key: 'configuration.impact-registrations.sort', route: 'v1/configuration/impact-registrations/sort'},
  {key: 'configuration.impact-registrations.read', route: 'v1/configuration/impact-registrations/:id'},
  {key: 'configuration.impact-registrations.update', route: 'v1/configuration/impact-registrations/:id'},
  {key: 'configuration.impact-registrations.delete', route: 'v1/configuration/impact-registrations/:id'},
  {key: 'configuration.impact-registrations.restore', route: 'v1/configuration/impact-registrations/:id/restore'},

  {key: 'overview', route: 'v1/overview'},
  {key: 'overview.tiles', route: 'v1/overview/features'},
  {key: 'overview.tile.tasks', route: 'v1/overview/:tile_id/tasks'},

  {key: 'dashboard.index', route: 'v1/dashboard'},

  {key: 'tasks.open', route: 'v1/tasks/open'},
  {key: 'tasks.closed', route: 'v1/tasks/closed'},
  {key: 'tasks.all', route: 'v1/tasks/all'},
  {key: 'tasks.count', route: 'v1/tasks/count'},
  {key: 'tasks.create', route: 'v1/tasks'},
  {key: 'tasks.import', route: 'v1/tasks/import'},
  {key: 'tasks.import.save', route: 'v1/tasks/import/save'},
  {key: 'tasks.import.download-example-json', route: 'v1/tasks/import/download-example-json'},
  {key: 'tasks.read', route: 'v1/tasks/:id'},
  {key: 'tasks.update', route: 'v1/tasks/:id'},
  {key: 'tasks.notes.create', route: 'v1/tasks/:id/notes'},
  {key: 'tasks.notes.update', route: 'v1/tasks/:id/notes/:note_id'},
  {key: 'tasks.delete', route: 'v1/tasks/:id'},
  {key: 'tasks.handle', route: 'v1/tasks/:id/handle'},
  {key: 'tasks.reopen', route: 'v1/tasks/:id/reopen'},
  {key: 'tasks.restore', route: 'v1/tasks/:id/restore'},
  {key: 'tasks.download-resolution-note-attachment', route: 'v1/tasks/:id/resolution-notes/:resolution_note_id/attachments/:attachment_id'},
  {key: 'tasks.export', route: 'v1/tasks/export/:pageType'},
  {key: 'tasks.rotate-photo', route: 'v1/tasks/:id/resolution-notes/:resolution_note_id/attachments/:attachment_id/rotate/:direction'},

  {key: 'tasks.reassign', route: 'v1/tasks/:id/reassign'},
  {key: 'tasks.assign-to-myself', route: 'v1/tasks/:id/assign-to-myself'},
  {key: 'tasks.forward', route: 'v1/tasks/:id/forward'},
  {key: 'tasks.history', route: 'v1/tasks/:id/history'},

  {key: 'knowledge-base.contact-details.index', route: 'v1/knowledge-base/support-contact-details'},
  {key: 'knowledge-base.faq.index', route: 'v1/knowledge-base/faq'},
  {key: 'knowledge-base.support-request', route: 'v1/knowledge-base/support-request'},
  {key: 'knowledge-base.kb.index', route: 'v1/knowledge-base'},
  {key: 'knowledge-base.kb.read', route: 'v1/knowledge-base/:url'},
  {key: 'knowledge-base.kb.articles', route: 'v1/knowledge-base/:articles/articles'},
  {key: 'knowledge-base.kb.article', route: 'v1/knowledge-base/:articles/articles/:article'},
  {key: 'knowledge-base.changelogs.index', route: 'v1/knowledge-base/changelogs'},
  {key: 'knowledge-base.changelogs.read', route: 'v1/knowledge-base/changelogs/:url'},
  {key: 'knowledge-base.changelogs.articles', route: 'v1/knowledge-base/changelogs/:changelog_url/articles'},

  {key: 'statistics.monthly-task', route: 'v1/statistics/monthly-task'},
  {key: 'statistics.monthly-task.export', route: 'v1/statistics/monthly-task/export'},
  {key: 'statistics.yearly-task', route: 'v1/statistics/yearly-task'},
  {key: 'statistics.yearly-task.export', route: 'v1/statistics/yearly-task/export'},
  {key: 'statistics.yearly-communication-task', route: 'v1/statistics/yearly-communication-task'},
  {key: 'statistics.yearly-communication-task.export', route: 'v1/statistics/yearly-communication-task/export'},
  {key: 'statistics.sources-task', route: 'v1/statistics/sources-task'},
  {key: 'statistics.sources-task.export', route: 'v1/statistics/sources-task/export'},
  {key: 'statistics.monthly-categories-task', route: 'v1/statistics/monthly-categories-task'},
  {key: 'statistics.monthly-categories-task.export', route: 'v1/statistics/monthly-categories-task/export'},
  {key: 'statistics.neighbourhood-monthly-categories-task', route: 'v1/statistics/neighbourhood-monthly-categories-task'},
  {key: 'statistics.neighbourhood-monthly-categories-task.export', route: 'v1/statistics/neighbourhood-monthly-categories-task/export'},
  {key: 'statistics.custom-compiled-task', route: 'v1/statistics/custom-compiled-task'},
  {key: 'statistics.custom-compiled-task.export', route: 'v1/statistics/custom-compiled-task/export'},
  {key: 'statistics.survey-task', route: 'v1/statistics/survey-task'},
  {key: 'statistics.survey-task.export', route: 'v1/statistics/survey-task/export'},
  {key: 'statistics.ranklist', route: 'v1/statistics/ranklist'},
  {key: 'statistics.ranklist.export', route: 'v1/statistics/ranklist/export'},

  {key: 'sent-emails.index', route: 'v1/sent-emails'},
  {key: 'sent-emails.message', route: 'v1/sent-emails/:id/message'},
  {key: 'sent-emails.logs', route: 'v1/sent-emails/:id/logs'},

  {key: 'sent-emails.events.index', route: 'v1/sent-emails/events'},
  {key: 'sent-emails.events.create', route: 'v1/sent-emails/events'},
  {key: 'sent-emails.events.read', route: 'v1/sent-emails/events/:id'},
  {key: 'sent-emails.events.update', route: 'v1/sent-emails/events/:id'},
  {key: 'sent-emails.events.delete', route: 'v1/sent-emails/events/:id'},
] as const;

type EndpointKey = typeof ENDPOINTS[number]['key'];
